<template>
    <!-- display customer account -->
    <div class="container-fluid">
        <div class="row my-3">
            <div class="col-9">
                <h4 v-if="accountName" class="add-ellipsis">Hi {{accountName}}!</h4>
                <h4 v-else>Account</h4>
            </div>
            <div class="col-3 text-right">
                <router-link :to="{ name: 'customer-settings' }" class="btn btn-outline-dark btn-sm">
                    <i class="fas fa-cog"></i> 
                    <span class="d-none d-sm-inline"> 
                        Settings
                    </span>
                </router-link>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-4 col-12 mb-3">
                <router-link :to="{ name: 'customer-orders' }">
                    <div class="card h-100 border-dark">
                        <div class="card-body text-center text-dark-green p-sm-2 p-md-5">
                            <h1>{{countSetOrders}}</h1>
                            <h4>Orders</h4>
                        </div>
                    </div>
                </router-link>
            </div>
            <div class="col-sm-4 col-12 mb-3">
                <router-link :to="{ name: 'shopping-cart' }">
                    <div class="card h-100 border-dark">
                        <div class="card-body text-center text-dark-green p-sm-2 p-md-5">
                            <h1>{{countCartItems}}</h1>
                            <h4>Cart Items</h4>
                        </div>
                    </div>
                </router-link>
            </div>
            <div class="col-sm-4 col-12 mb-3">
                <router-link :to="{ name: 'saved-later' }">
                    <div class="card h-100 border-dark">
                        <div class="card-body text-center text-dark-green p-sm-2 py-md-5">
                            <h1>{{countLaterItems}}</h1>
                            <h4>Saved Items</h4>
                        </div>
                    </div>
                </router-link>
            </div>
        </div>

        <!-- display saved address -->
        <div class="row mt-3">
            <div class="col-12 mb-3">
                <div class="card">
                    <div class="card-header bg-dark text-white">
                        <h5>Saved Address</h5>
                    </div>
                    <div class="card-body">
                        <div v-if="shopperAddress">
                            <p class="font-weight-bold">
                                <span v-if="shopperAddress.firstName && shopperAddress.lastName">
                                    {{shopperAddress.firstName | capitalize}},
                                    {{shopperAddress.lastName | capitalize}}<br>
                                </span>
                                <span class="text-dark-green">{{shopperAddress.email}}</span>
                            </p>
                            <p>
                                {{shopperAddress.address}},
                                {{shopperAddress.address2}} <br>
                                {{shopperAddress.city | capitalize}}, <br>
                                {{shopperAddress.state | capitalize}}, <br>
                                {{shopperAddress.country | capitalize}} <br>
                                {{shopperAddress.zipCode | capitalize}}
                            </p>
                            <p>
                                <router-link :to="{ name: 'customer-addresses' }" class="text-muted">
                                    Saved Addresses ({{shopperAddress.totalAddress}})
                                </router-link>
                            </p>
                        </div>
                        <div v-else>
                            <p>None</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { capitalizeWord, webpageTitle } from '@/store/dry'
import LayoutGeneral from '@/layouts/General.vue'

export default {
    name: "CustomerAccount",
    computed: {
        ...mapGetters(['user', 'setOrders', 'setAddresses']),
        accountName(){
            if(this.user){
                let userName = this.user.firstName && this.user.lastName ? this.user.firstName : this.user.name;
                // just split with space incase it's the name-property that gets picked
                let greetingName = userName.split(" ")[0]
                webpageTitle(capitalizeWord(greetingName))
                return `${capitalizeWord(greetingName)}`
            }
            return false
        },
        countSetOrders() {
            // obtain the customer orders from getters setOrders
            if(this.setOrders) {
                return this.setOrders.length
            }
            return 0
        },
        countCartItems() {
            // obtain the cart-items from local-storage and updated cart obj
            let localStorageATCItemIds = JSON.parse(localStorage.getItem('ani_items_atc')) 
            if(localStorageATCItemIds) {
                return localStorageATCItemIds.length
            }
            return 0
        },
        countLaterItems() {
            // obtain the saved-later-items from local-storage and updated saved later obj
            let localStorageSFLItemIds = JSON.parse(localStorage.getItem('ani_items_sfl')) 
            if(localStorageSFLItemIds) {
                return localStorageSFLItemIds.length
            } 
            return 0
        },
        shopperAddress() {
            // display shoppers current address
            if(this.user){
                let splittedName = this.user.name ? this.user.name.split(" ") : []
                let shopperAddressObj = {
                    firstName: this.user.firstName ? this.user.firstName : splittedName[0],
                    lastName: this.user.lastName ? this.user.lastName : splittedName[1],
                    email: this.user.email,
                    address: this.user.address,
                    address2: this.user.address2,
                    city: this.user.city,
                    state: this.user.state,
                    country: this.user.country,
                    alphaCode: this.user.alphaCode,
                    zipCode: this.user.zipCode,
                    totalAddress: this.setAddresses ? this.setAddresses.length : 0
                }
                return shopperAddressObj
            }
            return false
        }
    },
    created() {
        this.$emit('update:layout', LayoutGeneral);
    }
}
</script>